import { GlobalRail } from '@/components/layout/GlobalRail';
import { SiteWorkspaceNav } from '@/components/layout/SiteWorkspaceNav';

// LeftNav composes the two-part left navigation: the always-visible, icon-only
// GlobalRail for platform-scoped nav on the far left, and the wider
// SiteWorkspaceNav (persistent site switcher + site-scoped items) to its right.
// Replaces the single Sidebar that mixed both scopes and hid the site group
// when no site was selected.
export function LeftNav() {
  return (
    <>
      <GlobalRail />
      <SiteWorkspaceNav />
    </>
  );
}
